export enum BlockType {
  Start = 1000,
  Else = 0,
  Response = 1,
  UserInput = 2,
  Goto = 3,
  Button = 4,
  VideoBlock = 5,
  VideGoto = 6,
  VideoButton = 7,
  VideoLink = 8,
  PassToAi = 9,
  Variable = 10,
  TextLink = 11,
  HTTP = 12,
  Condition = 13,
  ElseCondition = 14,
  OverrideVariable = 15,
  CreateVariable = 16,
  Lead = 17,
  Media = 18,
  Attachment = 19,
  EndOFConversation = 20,
  Delay = 21,
  MakeWebHook = 22,
  NotifyMeByEmail = 23,
  ReceiveAttachment = 24,
  SUMLogin = 25,
  SUMLogout = 26,
  InjectTemplate = 27,
  GetUserInfo = 28,
  CheckUserExists = 29,
  UserLoginForm = 30,
  SwitchToChatbot = 31
}

type Block = {
  id: string;
  type: BlockType;
  title: string;
  parent: string | null;
  next?: string;
};

interface ElseBlock extends Block {
  type: BlockType.Else;
  title: "Else";
  next: string;
}

export enum ButtonType {
  Message = 0,
  Goto = 1
}

type Button = {
  title: string;
  type: ButtonType;
  payload: object;
};

interface MsgBtn extends Button {
  type: ButtonType.Message;
  payload: { message: string };
}

interface GotoBtn extends Button {
  type: ButtonType.Goto;
  payload: { next: string };
}

interface ResponseBlock extends Block {
  type: BlockType.Response;
  message: string;
  buttons: Array<MsgBtn | GotoBtn>;
}

interface UserInputBlock extends Block {
  type: BlockType.UserInput;
  keywords: string[];
  parent: string;
  next: string;
}

interface GotoBlock extends Block {
  type: BlockType.Goto;
  parent: string;
  next: string;
}

export type Blocks = ElseBlock | ResponseBlock | UserInputBlock | GotoBlock;
